import { FC } from 'react'
import spclasses from '../SetCourseClassDirectionModal/purchase.module.css'
import { CheckBoxLabel } from '@UI/CheckBox'
import InfoComp from '@pages/Admin/CRMSettings/components/InfoComp/InfoComp'

export interface IsPromoCheckboxProps {
  value?: boolean | null | undefined
  onChange?: (value: boolean | null | undefined) => void
  type: 'course' | 'class'
}

const IsPromoCheckbox: FC<IsPromoCheckboxProps> = ({
  value,
  onChange,
  type,
}) => {
  return (
    <div className={spclasses.inputWithLabel}>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <CheckBoxLabel
          type="button"
          value={!!value}
          onClick={() => onChange?.(!value)}
          label="Можно использовать промокод"
          className={spclasses.checkboxWithLabel}
          style={{
            justifyContent: 'flex-start',
            paddingTop: '4px',
            paddingBottom: '4px',
            height: 'auto',
          }}
        />
        <InfoComp
          text={`При включенном чекбоксе учащийся сможет воспользоваться промокодом при покупке ${
            type === 'course' ? 'курса' : 'класса'
          }`}
        />
      </div>
    </div>
  )
}

export default IsPromoCheckbox
